// cms
export const toggleEditMode = "toggleEditMode";
export const toggleSettings = "toggleSettings";
export const toggleGeneral = "toggleGeneral";
export const toggleCreatePage = "toggleCreatePage";
export const changePageLang = "changePageLang";
export const changeHeaderLang = "changeHeaderLang";
export const changePage = "changePage";
export const getIsPublishedLang = "getIsPublishedLang";
export const hasSlug = "hasSlug";
export const updatePageDataField = "updatePageDataField";
export const updateIsPublishedPageForLang = "updateIsPublishedPageForLang";
export const updateIsPublishedPage = "updateIsPublishedPage";
export const checkHasPageChanges = "checkHasPageChanges";
export const checkHasHeaderChanges = "checkHasHeaderChanges";
export const cancelPageChanges = "cancelPageChanges";
export const cancelHeaderChanges = "cancelHeaderChanges";
export const removeLang = "removeLang";
export const removePage = "removePage";
export const updateSeoField = "updateSeoField";
export const setTemplate = "setTemplate";
export const updateOrderBlocks = "updateOrderBlocks";
export const updateOrderHeaderGroupes = "updateOrderHeaderGroupes";
export const updateOrderHeaderSubLinks = "updateOrderHeaderSubLinks";
export const toggleShowBlock = "toggleShowBlock";
export const toggleShowHeaderSubLink = "toggleShowHeaderSubLink";
export const removeBlock = "removeBlock";
export const removeHeaderSubLink = "removeHeaderSubLink";
export const addBlock = "addBlock";
export const updateDataBlock = "updateDataBlock";
export const toggleActiveSeo = "toggleActiveSeo";
export const setActiveGeneralTab = "setActiveGeneralTab";
export const savePageChange = "savePageChange";
export const setInitLangTemplate = "setInitLangTemplate";
export const getBlockByIndex = "getBlockByIndex";
export const updateBlockIndex = "updateBlockIndex";
export const resetBlockIndex = "resetBlockIndex";
export const updateBlockSettings = "updateBlockSettings";
export const toggleShowHeader = "toggleShowHeader";
export const addHeaderLink = "addHeaderLink";
export const addHeaderMenu = "addHeaderMenu";
export const updateHeaderGroupe = "updateHeaderGroupe";
export const toggleShowHeaderGroupe = "toggleShowHeaderGroupe";
export const removeHeaderGroupe = "removeHeaderGroupe";
export const updateHeaderSubLink = "updateHeaderSubLink";
export const createNewPage = "createNewPage";
export const updateCollectionType = "updateCollectionType";
export const getLangBlocks = "getLangBlocks";
export const addNewSetLink = "addNewSetLink";
export const changeSetsLang = "changeSetsLang";
export const setToEditSet = "setToEditSet";
export const updateSetData = "updateSetData";
export const updateHeaderMenu = "updateHeaderMenu";
export const updateSlug = "updateSlug";
export const checkValidatePage = "checkValidatePage";
export const updateInternalTitle = "updateInternalTitle";
export const updatePropertyField = "updatePropertyField";
export const updatePageType = "updatePageType";
export const setListSets = "setListSets";
export const checkHasSetChanges = "checkHasSetChanges";
export const removeSetLink = "removeSetLink";
export const updateSetLink = "updateSetLink";
export const cancelSetsChanges = "cancelSetsChanges";
export const updateOrderSetLinks = "updateOrderSetLinks";
export const updateLangPageData = "updateLangPageData";
export const validatePageRules = "validatePageRules";
export const changeWidgetLang = "changeWidgetLang";
export const checkHasWidgetChanges = "checkHasWidgetChanges";
export const toggleIsWidgetEditing = "toggleIsWidgetEditing";
export const cancelWidgetChanges = "cancelWidgetChanges";
export const updateWidget = "updateWidget";
export const convertToWidget = "convertToWidget";
export const detachWidget = "detachWidget";
export const addWidgetToWidgetsList = "addWidgetToWidgetsList";
export const addWidgetsToWidgetsList = "addWidgetsToWidgetsList";
export const updateWidgetTitle = "updateWidgetTitle";
export const startEditWidget = "startEditWidget";
export const endEditWidget = "endEditWidget";
export const updateDataWidget = "updateDataWidget";
export const toggleShowWidgetLang = "toggleShowWidgetLang";
export const setIsPageNotFound = "setIsPageNotFound";
export const getBlockLocale = "getBlockLocale";
export const actualizeSettings = "actualizeSettings";
export const updateIsHiddenPageForLang = "updateIsHiddenPageForLang";
export const updateIsHiddenPage = "updateIsHiddenPage";
export const resetPageRules = "resetPageRules";
export const setPendingUserDeletionId = "setPendingUserDeletionId";
export const setPagesWithWidget = "setPagesWithWidget";

// user
export const updateProfile = "updateProfile";
export const resetProfile = "resetProfile";
// refund
export const resetRefund = "resetRefund";
export const updateRefund = "updateRefund";
// giftCard
export const resetGiftCard = "resetGiftCard";
export const updateGiftCard = "updateGiftCard";
export const updateGiftCardFormData = "updateGiftCardFormData";
// payment
export const resetPayment = "resetPayment";
export const updatePayment = "updatePayment";
export const updateBasket = "updateBasket";
export const updateBasketValid = "updateBasketValid";
export const updatePaymentStartAt = "updatePaymentStartAt";
// search
export const resetSearch = "resetSearch";
export const swapDirections = "swapDirections";
export const updatePassengers = "updatePassengers";
export const updateSearch = "updateSearch";
export const updateDestination = "updateDestination";
export const validatePassengers = "validatePassengers";
// app
export const resetApp = "resetApp";
export const updateApp = "updateApp";
export const changeCurrency = "changeCurrency";
// modals
export const resetModals = "resetModals";
export const updateModals = "updateModals";
// tickets
export const resetTickets = "resetTickets";
export const updateTickets = "updateTickets";
export const changeSeatNumber = "changeSeatNumber";
export const updateSeatPlan = "updateSeatPlan";
export const updatePrices = "updatePrices";
export const updateBicycles = "updateBicycles";
export const updateTransfers = "updateTransfers";
export const updateIsCampaign = "updateIsCampaign";
export const setSeatShiftNotified = "setSeatShiftNotified";
export const setMultiFloorOccupiedBusNotified =
  "setMultiFloorOccupiedBusNotified";
export const updateLegsViewed = "updateLegsViewed";
export const setBusFloor = "setBusFloor";
export const updateFareClasses = "updateFareClasses";
export const setNewFareClasses = "setNewFareClasses";
export const initUpdateFareClasses = "initUpdateFareClasses";
// change tickets
export const resetChangeTickets = "resetChangeTickets";
export const updateChangeTickets = "updateChangeTickets";
export const changeSeatNumberChangeTickets = "changeSeatNumberChangeTickets";
export const updateSeatPlanChangeTickets = "updateSeatPlanChangeTickets";
export const updateBicyclesChangeTickets = "updateBicyclesChangeTickets";
export const updateTransfersChangeTickets = "updateTransfersChangeTickets";

// ssrData
export const resetSsrData = "resetSsrData";
export const updateSsrData = "updateSsrData";
